// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.screen-share-notifications {
  position: fixed;
  top: 80px;
  right: 20px;
  z-index: 1500;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.screen-share-notification {
  background: #2d2d2d;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  padding: 16px;
  min-width: 300px;
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.notification-content {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.notification-icon {
  font-size: 24px;
}

.notification-text {
  font-size: 14px;
  color: white;
  line-height: 1.4;
}

.notification-text strong {
  color: #4CAF50;
}

.notification-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.notification-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.notification-btn.approve {
  background: #4CAF50;
  color: white;
}

.notification-btn.approve:hover {
  background: #45a049;
}

.notification-btn.deny {
  background: rgba(255, 255, 255, 0.1);
  color: white;
}

.notification-btn.deny:hover {
  background: rgba(255, 255, 255, 0.15);
}

@media (max-width: 768px) {
  .screen-share-notifications {
    top: 60px;
    right: 10px;
    left: 10px;
  }

  .screen-share-notification {
    min-width: auto;
    padding: 12px;
  }

  .notification-content {
    gap: 8px;
  }

  .notification-text {
    font-size: 13px;
  }

  .notification-actions {
    gap: 6px;
  }

  .notification-btn {
    padding: 6px 12px;
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ScreenShareNotification.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,SAAS;IACT,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF","sourcesContent":[".screen-share-notifications {\r\n  position: fixed;\r\n  top: 80px;\r\n  right: 20px;\r\n  z-index: 1500;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n.screen-share-notification {\r\n  background: #2d2d2d;\r\n  border-radius: 12px;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\r\n  padding: 16px;\r\n  min-width: 300px;\r\n  animation: slideIn 0.3s ease-out;\r\n}\r\n\r\n@keyframes slideIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateX(100%);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n.notification-content {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  margin-bottom: 12px;\r\n}\r\n\r\n.notification-icon {\r\n  font-size: 24px;\r\n}\r\n\r\n.notification-text {\r\n  font-size: 14px;\r\n  color: white;\r\n  line-height: 1.4;\r\n}\r\n\r\n.notification-text strong {\r\n  color: #4CAF50;\r\n}\r\n\r\n.notification-actions {\r\n  display: flex;\r\n  gap: 8px;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.notification-btn {\r\n  padding: 8px 16px;\r\n  border: none;\r\n  border-radius: 6px;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.notification-btn.approve {\r\n  background: #4CAF50;\r\n  color: white;\r\n}\r\n\r\n.notification-btn.approve:hover {\r\n  background: #45a049;\r\n}\r\n\r\n.notification-btn.deny {\r\n  background: rgba(255, 255, 255, 0.1);\r\n  color: white;\r\n}\r\n\r\n.notification-btn.deny:hover {\r\n  background: rgba(255, 255, 255, 0.15);\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .screen-share-notifications {\r\n    top: 60px;\r\n    right: 10px;\r\n    left: 10px;\r\n  }\r\n\r\n  .screen-share-notification {\r\n    min-width: auto;\r\n    padding: 12px;\r\n  }\r\n\r\n  .notification-content {\r\n    gap: 8px;\r\n  }\r\n\r\n  .notification-text {\r\n    font-size: 13px;\r\n  }\r\n\r\n  .notification-actions {\r\n    gap: 6px;\r\n  }\r\n\r\n  .notification-btn {\r\n    padding: 6px 12px;\r\n    font-size: 12px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
